import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import { getCookie } from "@/assets/js/cookie.js";

export default new Vuex.Store({
  state: {
    logined: false, // 是否登录
    user: {}, // 当前用户
    type_list: [
      {
        name: "模考大赛",
        id: 1,
      },
      {
        name: "历年真题",
        id: 2,
      },
      {
        name: "知识点练习",
        id: 3,
      },
      {
        name: "练习记录",
        id: 4,
      },
      {
        name: "错题本",
        id: 5,
      },
    ],
    max_upload_img: 3,
  },
  getters: {},
  mutations: {
    SET_LOGINED(state, payload) {
      if (payload) {
        state.logined = payload;
      } else {
        if (getCookie("logined")) {
          state.logined = getCookie("logined");
        } else {
          state.logined = false;
        }
      }
    },
    SET_USER(state, payload) {
      if (payload) {
        state.user = payload;
      } else {
        if (getCookie("userInfo")) {
          state.user = JSON.parse(getCookie("userInfo"));
        } else {
          state.user = {};
        }
      }
    },
  },
  actions: {
    setUserAndState({ commit }, user) {
      if (user) {
        commit("SET_LOGINED", true);
      } else {
        commit("SET_LOGINED", false);
      }
      commit("SET_USER", user);
    },
  },
  modules: {},
});
